import type {Result, UseCase} from 'framework';
import type {SettingsError} from '../../domain/errors';
import type {ReminderKind, UserReminder} from '../../domain/user-reminder';
import type {SettingsRepository} from '../ports/settings.repository';

export type AcknowledgeReminderInput = {
  readonly kind: ReminderKind;
};

export class AcknowledgeReminder implements UseCase<[AcknowledgeReminderInput], UserReminder> {
  constructor(private readonly repository: SettingsRepository) {}

  execute(input: AcknowledgeReminderInput): Promise<Result<UserReminder, SettingsError>> {
    return this.repository.acknowledgeReminder(input.kind);
  }
}
